import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Plane, MapPin, TowerControl } from "lucide-react";
import api from "../lib/api";

/* IndianAirports.com — airline profile: the Indian airports this airline connects. */
export default function IndiaAirlineDetail() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setData(null); setErr(false);
    api.get(`/india/airlines/${slug}`).then((r) => {
      setData(r.data);
      document.title = `${r.data.name} at Indian Airports — IndianAirports.com`;
    }).catch(() => setErr(true));
    window.scrollTo(0, 0);
  }, [slug]);

  if (err) return <div className="max-w-4xl mx-auto px-5 py-16 text-center text-sm text-zinc-500" data-testid="india-airline-notfound">Airline not found. <Link to="/india/airlines" className="text-blue-700 font-700 hover:underline">Browse all airlines</Link></div>;
  if (!data) return <div className="max-w-4xl mx-auto px-5 py-12 text-sm text-zinc-500">Loading airline…</div>;

  return (
    <div className="max-w-5xl mx-auto px-5 py-10" data-testid="india-airline-detail">
      <Link to="/india/airlines" className="text-xs font-700 text-blue-700 inline-flex items-center gap-1 hover:underline" data-testid="india-airline-back"><ArrowLeft className="w-3.5 h-3.5" /> All airlines</Link>
      <div className="mt-2 flex items-center gap-3">
        <span className="inline-flex p-3 rounded-2xl bg-blue-700 text-white"><Plane className="w-6 h-6" /></span>
        <div>
          <h1 className="font-heading font-900 text-4xl sm:text-5xl tracking-tight" data-testid="india-airline-name">{data.name}</h1>
          <p className="text-sm text-zinc-500">{data.airports_served} Indian airports served{data.hub_count > 0 ? ` · ${data.hub_count} hub${data.hub_count > 1 ? "s" : ""}` : ""}</p>
        </div>
      </div>
      <h2 className="mt-8 font-heading font-800 text-base md:text-lg">Airports {data.name} connects in India</h2>
      <div className="mt-3 grid sm:grid-cols-2 gap-3" data-testid="india-airline-airports">
        {data.airports.map((a) => (
          <Link key={a.iata} to={`/india/airports/${a.slug}`} data-testid={`india-airline-airport-${a.iata}`}
            className="flex items-center gap-3 bg-white border border-zinc-200 rounded-2xl px-3 py-2.5 hover:border-blue-400">
            <img src={a.image_url} alt="" className="w-14 h-10 rounded-lg object-cover shrink-0" loading="lazy" />
            <span className="flex-1 min-w-0">
              <span className="block text-sm font-700 truncate">{a.name}</span>
              <span className="block text-[11px] text-zinc-500 inline-flex items-center gap-1"><MapPin className="w-3 h-3" /> {a.city}, {a.state} · <b className="font-mono">{a.iata}</b></span>
            </span>
            {a.is_hub && <span className="shrink-0 inline-flex items-center gap-1 text-[10px] font-800 uppercase bg-emerald-50 text-emerald-700 border border-emerald-200 rounded px-1.5 py-0.5"><TowerControl className="w-3 h-3" /> Hub</span>}
          </Link>
        ))}
      </div>
      <p className="mt-6 text-xs text-zinc-400">Airline presence is derived from each airport's verified profile — always confirm schedules with the airline.</p>
    </div>
  );
}
